/**
 * SearchBar — canonical search input used in every left panel top section.
 * Wraps a navy3 input with an embedded search icon.
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { colors, fonts } from './colors';

interface SearchBarProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder = 'Search...' }) => {
  return (
    <div style={{ position: 'relative', flex: 1 }}>
      <FontAwesomeIcon
        icon={faSearch}
        style={{
          position: 'absolute',
          left: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          color: colors.muted,
          fontSize: '12px',
          pointerEvents: 'none',
        }}
      />
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: '100%',
          background: colors.navy3,
          border: 'none',
          borderRadius: '6px',
          padding: '8px 10px 8px 30px',
          color: colors.white,
          fontSize: '13px',
          outline: 'none',
          fontFamily: fonts.body,
        }}
      />
    </div>
  );
};

export default SearchBar;
